export default class Documents {
    constructor(documents) {
        this.documents = documents;
    }
}